export const inventoryRoute = '/inventory';

export { Inventory } from '../../../shared/components/Inventory/index';
